import { useSuspenseQuery } from "@apollo/client/react";
import {
  GetDbpjKitWorkerJobsDocument,
  type GetDbpjKitWorkerJobsQuery,
  type GetDbpjKitWorkerJobsQueryVariables,
} from "~/features/dbpjkitWorkerJobs/gqls";
import { buildJobDetailVariables } from "~/features/dbpjkitWorkerJobs/utils/transformers";
import { useTenant } from "~/features/tenant/context";

/** Read a single job (Job Information card + latest run) for the current tenant. */
export function useDbpjkitWorkerJobDetail(id: string) {
  const { tenantId } = useTenant();
  if (!tenantId) throw new Error("Tenant ID is required");
  return useSuspenseQuery<GetDbpjKitWorkerJobsQuery, GetDbpjKitWorkerJobsQueryVariables>(GetDbpjKitWorkerJobsDocument, {
    variables: buildJobDetailVariables(tenantId, id),
  });
}
